import Icon from './components/Icon';
import Svg from './svg/assessment.svg';
export default props => <Icon component={Svg} data-name="Assessment" {...props} />;